export default __webpack_public_path__ + "static/media/course.7128b73e.png";